module.exports = __webpack_public_path__ + "img/neckline length.bfb1e6f2.png";